function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isArray, isEqual } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
export default {
  name: buildComponentName('Collapse'),
  provide: function provide() {
    return {
      collapseRoot: this
    };
  },
  model: {
    prop: 'activeKeys'
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-collapse'
    },
    activeKeys: {
      type: [String, Number, Array],
      default: ''
    },
    accordion: {
      type: Boolean,
      default: false
    },
    destroyInactivePanel: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    control: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerActiveKeys: null
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          border = this.border;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-borderless"), !border), _ref;
    }
  },
  watch: {
    activeKeys: function activeKeys(nVal, oVal) {
      if (!isEqual(nVal, oVal)) {
        this.setInnerActiveKeys(nVal);
      }
    }
  },
  created: function created() {
    var activeKeys = this.activeKeys,
        setInnerActiveKeys = this.setInnerActiveKeys;
    setInnerActiveKeys(activeKeys);
  },
  methods: {
    setInnerActiveKeys: function setInnerActiveKeys() {
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.innerActiveKeys = isArray(keys) ? keys : [keys];
    },
    onHeaderClick: function onHeaderClick(key) {
      var control = this.control,
          innerActiveKeys = this.innerActiveKeys,
          accordion = this.accordion,
          setInnerActiveKeys = this.setInnerActiveKeys;
      var idx = innerActiveKeys.indexOf(key);

      var keys = _toConsumableArray(innerActiveKeys);

      if (accordion) {
        keys = idx > -1 ? [] : [key];
      } else if (idx > -1) {
        keys.splice(idx, 1);
      } else {
        keys.push(key);
      }

      if (!control) {
        setInnerActiveKeys(keys);
      }

      var val = accordion ? keys[0] : keys;
      this.$emit('input', val);
      this.$emit('change', val);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        classes = this.classes,
        accordion = this.accordion;
    return h("div", {
      "class": classes,
      "attrs": {
        "role": accordion ? 'tablist' : null
      }
    }, [$slots.default]);
  }
};